module.exports = __webpack_public_path__ + "img/sv.475d7005.svg";